module.exports = __webpack_public_path__ + "static/img/web_mobile_code03.9641e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_mobile_code03.png
// module id = IBQ5
// module chunks = 1